export default {
  sections: [],
  sectionsForSelect: [],
}
